import React, { useState, useEffect } from "react";
import styles from "./Privacy.module.css";
import { Container } from "@mui/system";
import { Typography } from "@mui/material";
import { getResponsiveModalWidth } from "utils/helpers"
import ModalLayout from "component/modalLayout/ModalLayout";
import Terms from "pages/auth/signUp/modals/terms/Terms";
import Policy from "../privacy/modals/Policy"
import form_icon from "../../assets/images/application-form-icon.svg"


function Privacy() {

    const [openTerms, setOpenTerms] = useState(false);
    const [openPolicy, setOpenPolicy] = useState(true);
    const [width, setWidth] = useState(getResponsiveModalWidth());

    useEffect(() => {
        getResponsiveModalWidth();
        window.addEventListener("resize", () => {
            setWidth(getResponsiveModalWidth());
        });
    }, []);

    return (
        <>
            <Container maxWidth="lg">
                <div className={styles.privacy_card}>
                    <Typography>
                        Stanbic IBTC Bank's{" "}
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                setOpenTerms(true);
                            }}
                        >
                            {" "}
                            Terms{" "}
                        </a>
                        &{" "}
                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                setOpenTerms(true);
                            }}
                            href="/"
                        >
                            {" "}
                            Conditions{" "}
                        </a>,{" "}

                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                setOpenPolicy(true);
                            }}
                            href="/"
                        >
                            {" "}
                            Privacy Policy{" "}
                        </a>,{" "}



                        guiding the use of this platform
                    </Typography>
                </div>
            </Container>

            {openTerms && (
                <ModalLayout
                    icon={form_icon}
                    title="Terms & Conditions"
                    handleClose={() => {
                        setOpenTerms(false);
                    }}
                    width={width}
                    openModal={openTerms}
                    children={<Terms />}
                />
            )}

        {openPolicy && (
                <ModalLayout
                    icon={form_icon}
                    title="Privacy Policy"
                    handleClose={() => {
                        setOpenPolicy(false);
                    }}
                    width={width}
                    openModal={openPolicy}
                    children={<Policy />}
                />
            )}
        </>
    )

}


export default Privacy